import "./App.less";
import React, { useEffect } from "react";
import { BrowserRouter, useLocation, useNavigate } from "react-router-dom";
import { initializeTagManager } from "./gtm";

import "antd/dist/antd.css";
import "./assets/styles/main.less";
import "./assets/styles/responsive.less";

import AppRoutes from "./routes/AppRoutes";
import { getUser } from "./Utils/isAuth";
import useIdleLogout from "./hooks/useIdleLogout";
import { message } from "antd";
import {  getUserDetail,} from "./api";

function App() {
  const user = getUser();
  const handleOnIdle = () => {
    if (window.location.pathname === '/login') {
      return;
    }
    // Perform logout actions
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    message.error('You have been logged out due to inactivity. Please login again.');
    window.location.href = '/login';
  };

  useIdleLogout(handleOnIdle, 30 * 60 * 1000); // 30 minutes

  useEffect(() => {
    initializeTagManager();
    const token = localStorage.getItem("token");
    if (!token) return;

    async function getUserData() {
      const { data } = await getUserDetail(token);
      const existingUser = JSON.parse(localStorage.getItem("user") || "{}");
      const updatedUser = { ...existingUser, ...data };
      localStorage.setItem("user", JSON.stringify(updatedUser));
    }

    getUserData();
  }, []);



  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
